module.exports = __webpack_public_path__ + "assets/images/fengshi.b69e28e1ea11121700e976f80f3afc40.png";